import Iubenda from "react-iubenda-policy";
import CookieConsent from "react-cookie-consent";
function Cookies() {
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  const desktopStyle = {
    background: "#010f1d",
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    maxWidth: "100vw",
    width: "100%",
    flexWrap: "wrap",
    justifyContent: "center",
    boxSizing: "border-box",
    padding: "1rem 0.5rem",
  };

  const mobileStyle = {
    background: "#010f1d",
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    maxWidth: "100vw",
    width: "100%",
    flexWrap: "wrap",
    justifyContent: "center",
    boxSizing: "border-box",
  };
  return (
    <CookieConsent
      // containerClasses="cookie-banner"
      buttonText="ACCETTO"
      cookieName="prossimiti-coockies"
      enableDeclineButton
      flipButtons
      declineButtonText={"RIFIUTO"}
      expires={999}
      style={isMobile ? mobileStyle : desktopStyle}
      contentStyle={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "center",
        textAlign: "center",
        width: "100%",
        wordBreak: "break-word",
      }}
      buttonStyle={{
        background: "#11acd3",
        color: "white",
        fontWeight: "bold",
        height: "1rem",
        fontSize: " 0.8rem",
        padding: "1rem",
        cursor: "pointer",
        borderRadius: "32px",
        outline: "none",
        display: "inline-flex	",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Montserrat, sans-serif",
      }}
      declineButtonStyle={{
        background: "#ff0000",
        color: "white",
        fontWeight: "bold",
        height: "1rem",
        fontSize: " 0.8rem",
        padding: "1rem",
        cursor: "pointer",
        borderRadius: "32px",
        outline: "none",
        display: "inline-flex	",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Montserrat, sans-serif",
      }}
    >
      <span
        style={{
          fontSize: "0.8rem",
          fontFamily: "Montserrat, sans-serif",
          color: "white",
          display: "block",
          width: "100%",
          wordBreak: "break-word",
          textAlign: "center",
          lineHeight: 1.5,
        }}
      >
        Questo sito utilizza i cookie per migliorare servizi e esperienza dei
        lettori.
        <br />
        Se decidi di continuare la navigazione consideriamo che accetti il loro
        uso.
      </span>

      <Iubenda id={60147723} type="cookie" styling="white">
        Cookie Policy
      </Iubenda>
    </CookieConsent>
  );
}

export default Cookies;
